var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsightsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1211_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1743 19.9927C17.2324 21.7147 14.6955 22.7494 11.9114 22.7494C5.84802 22.7494 0.920654 17.822 0.920654 11.7587C0.920654 5.6953 5.4818 1.14359 11.2245 0.79541V5.39305C8.00967 5.73179 5.50026 8.46144 5.50026 11.7587C5.50026 15.2941 8.37631 18.1698 11.9114 18.1698C13.4316 18.1698 14.8329 17.6387 15.932 16.75L19.1743 19.9923V19.9927Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8748 12.4456C22.7284 14.955 21.7298 17.245 20.1456 19.0215L16.9033 15.7793C17.6542 14.8541 18.1488 13.7 18.2772 12.4456H22.8748Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8747 11.0717H18.2771C17.9658 8.08578 15.5843 5.70474 12.5984 5.39305V0.79541C18.1122 1.12513 22.545 5.55791 22.8747 11.0717Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1211_139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.954,
    height: 21.954,
    fill: "white",
    transform: "translate(0.920654 0.79541)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsIcon);
export default __webpack_public_path__ + "static/media/InsightsIcon.cb317a811419d8d139d9d1c933fa834c.svg";
export { ForwardRef as ReactComponent };